export default "__VITE_ASSET__8TTkjap0__"